import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  filtersContainer: {
    padding: theme.spacing(2),
    alignItems: "center",
  },
  filterItem: {
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2.5),
  },
  searchButton: {
    minWidth: 100,
    height: 40,
    whiteSpace: "nowrap",
  },
  deviceSelect: {
    width: "100%",
    "& .MuiSelect-root": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  deviceSelectError: {
    width: "100%",
    "& .MuiSelect-root": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.error.main,
    },
  },
  deviceHeader: {
    fontWeight: 700,
    opacity: 1,
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
  },
  dateErrorWrapper: {
    position: "relative",
    overflow: "visible",
  },
  dateErrorText: {
    color: theme.palette.error.main,
    fontSize: "0.75rem",
    whiteSpace: "nowrap",
    position: "absolute",
    top: "100%",
    left: 0,
    marginTop: 4,
    zIndex: 1,
  },
}));
